import { Container, Grid, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import barista from "../../assets/aboutUs/barista.jpg";
import BannerBox from "../../components/home/bannerBox.js";
import { NOT_FOUND } from "../../locales/pages/namespaces.js";

const NotFound = () => {
  const { t } = useTranslation(NOT_FOUND);
  const history = useHistory();

  return (
    <Container maxWidth="lg" sx={{ py: { xs: 4, md: 8 } }}>
      <Stack spacing={3} alignItems="center">
        <Typography
          variant="h3"
          align="center"
          sx={{
            fontSize: 48,
            fontWeight: 900,
            fontFamily: "Zen Maru Gothic, Arial, sans-serif",
            letterSpacing: 0.5,
            lineHeight: 1.05,
          }}
        >
          {t("It seems")}
        </Typography>

        <Typography
          color="text.secondary"
          align="center"
          sx={{
            fontFamily: "Zen Maru Gothic, Arial, sans-serif",
            fontSize: 20,
            fontWeight: 500,
            maxWidth: { xs: "92%", md: "720px" },
            pb: 3,
          }}
        >
          {t("Suggests")}
        </Typography>

        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6} md={4}>
            <BannerBox
              title={t("HOME PAGE")}
              image={barista}
              onClick={() => {
                history.push("/");
              }}
              height={{ xs: "200px", md: "210px" }}
              width="100%"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <BannerBox
              title={t("BREW PRODUCTS")}
              image={barista}
              onClick={() => history.push(`/products?brand=brew`)}
              height={{ xs: "200px", md: "210px" }}
              width="100%"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <BannerBox
              title={t("LUNOR PRODUCTS")}
              image={barista}
              onClick={() => history.push(`/products?brand=lunor`)}
              height={{ xs: "200px", md: "210px" }}
              width="100%"
            />
          </Grid>
        </Grid>
      </Stack>
    </Container>
  );
};

export default NotFound;
